/* ============================================================
   Metal Prices – Fetcher
   Shopiweb Premium v1.7.0
   ============================================================ */

const METAL_API_URL =
  "https://api.metalpriceapi.com/v1/latest?api_key=xx&base=EUR&currencies=XAU,XAG,XPD,XPT";

const TROY_OZ_TO_G = 31.1035;
const FALLBACK_MSG = "Nos prix sont indexés en temps réel sur les cours mondiaux des métaux précieux";

function ozToGram(pricePerOz) {
  if (!pricePerOz || pricePerOz <= 0) return null;
  return (pricePerOz / TROY_OZ_TO_G).toLocaleString("fr-FR", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}

function setPrice(id, value) {
  const el = document.getElementById(id);
  if (el) el.textContent = value !== null ? value : "N/D";
}

function showFallback() {
  const bar = document.getElementById("metal-top-bar");
  if (!bar) return;
  bar.innerHTML =
    '<span id="metal-top-bar-fallback">' + FALLBACK_MSG + "</span>";
}

async function fetchMetalPrices() {
  try {
    const response = await fetch(METAL_API_URL);
    if (!response.ok) throw new Error("HTTP " + response.status);

    const data = await response.json();

    // API retourne success: false (quota dépassé, clé invalide, etc.)
    if (!data.success || !data.rates) {
      console.warn("Metal API indisponible:", data?.error?.message || "Erreur inconnue");
      showFallback();
      return;
    }

    setPrice("price-xau", ozToGram(data.rates.EURXAU));
    setPrice("price-xag", ozToGram(data.rates.EURXAG));
    setPrice("price-xpt", ozToGram(data.rates.EURXPT));
    setPrice("price-xpd", ozToGram(data.rates.EURXPD));

  } catch (error) {
    console.error("Metal prices fetch error:", error);
    showFallback();
  }
}

fetchMetalPrices();
setInterval(fetchMetalPrices, 3000000000);